import { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
} from '@mui/material'
import {
  Login as LoginIcon,
  Logout as LogoutIcon,
} from '@mui/icons-material'

interface LayoutProps {
  children: ReactNode
}

export default function Layout({ children }: LayoutProps) {
  const { isAuthenticated, logout } = useAuth()
  const navigate = useNavigate()

  return (
    <>
      <AppBar position="static">
        <Toolbar>
          <Typography 
            variant="h6" 
            component="div" 
            sx={{ flexGrow: 1, cursor: 'pointer' }}
            onClick={() => navigate('/')}
          >
            CloudPaste
          </Typography>
          {isAuthenticated ? (
            <Button 
              color="inherit" 
              onClick={logout}
              startIcon={<LogoutIcon />}
            >
              退出登录
            </Button>
          ) : (
            <Button 
              color="inherit" 
              onClick={() => navigate('/login')}
              startIcon={<LoginIcon />}
            >
              登录
            </Button>
          )}
        </Toolbar>
      </AppBar>
      {children}
    </>
  )
} 